<script>
import { styleState } from "@app/store/styleStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
import * as m from '@app/paraglide/messages.js';

function moveUpOneLine() {
    // Get current event group's display dimensions
    const displayHeight = styleState.height || 15;

    eventGroupState[projectState.selected].selected.forEach((evIndex) => {
        try {
            let currentY;

            // Get current Y position (line number)
            if (
                typeof eventGroupState[projectState.selected].events[evIndex]
                    .yPos === "number"
            ) {
                currentY =
                    eventGroupState[projectState.selected].events[evIndex].yPos;
            } else {
                // Convert string position to number
                switch (
                    eventGroupState[projectState.selected].events[evIndex].yPos
                ) {
                    case "start":
                        currentY = 1;
                        break;
                    case "center":
                        currentY = Math.floor(displayHeight / 2);
                        break;
                    case "end":
                        currentY = displayHeight;
                        break;
                    default:
                        currentY = displayHeight; // Default to bottom
                }
            }

            // Move up one line (subtract 1), but don't go below 1
            const newY = Math.max(1, currentY - 1);
            eventGroupState[projectState.selected].events[evIndex].yPos = newY;
        } catch (err) {
            console.error("Position line up error");
            console.error(err.message);
            console.log(err);
        }
    });

    insertHistoryAction({
        name: "position line up", //action name
        eventGroup: projectState.selected,
        snapshots: [
            {
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState),
            },
        ],
    });
}
</script>

<li class="nav-item" title={m.position_line_up_title()}>
    <a
        class="nav-link"
        href="#!/"
        role="button"
        id="position-line-up-btn"
        aria-label={m.position_line_up_aria_label()}
        class:disabled={!eventGroupState[projectState.selected] ||
            eventGroupState[projectState.selected].selected.length === 0}
        aria-disabled={!eventGroupState[projectState.selected] ||
            eventGroupState[projectState.selected].selected.length === 0}
        onclick={moveUpOneLine}>
        <i class="bi bi-chevron-up" aria-hidden="true"></i>
    </a>
</li>
